import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';

export const StyledSearchWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: max-content;
  padding: 10px 35px 10px 16px;
  border-radius: 6px;
  border-width: 1px;
  border-style: solid;
  border-color: ${themeGet('colors.text.border')};
  color: ${themeGet('colors.text.border')};

  > svg {
    position: absolute;
    right: 14px;
    top: 12px;
  }

  &:not(:last-child) {
    margin-bottom: 18px;
  }
`;
